export default __webpack_public_path__ + "static/media/close.a5d18ded.svg";